enum MediaEventType {
    ENDED = 'ended',
    PAUSE = 'pause',
    LOADED_META_DATA = 'loadedmetadata',
    PLAY = 'play',
    VOLUME_CHANGE = 'volumechange'
}

export default MediaEventType;